import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-flight-takeoff-line', title: 'Havayolu Taşımacılığı', desc: 'Tüm havayolu yüklerinizi ekonomik çözümlerle dünyanın her noktasına teslim ediyoruz.' },
  { icon: 'ri-truck-line', title: 'Karayolu Parsiyel (LTL)', desc: 'Karayolu parsiyel yüklerinizi güvenli ve ekonomik şekilde taşıyoruz.' },
  { icon: 'ri-truck-fill', title: 'Full Kamyon (FTL)', desc: 'Full kamyon yüklerinizi zamanında ve güvenle teslim ediyoruz.' },
  { icon: 'ri-ship-line', title: 'Full Konteyner (FCL)', desc: 'Full konteyner yüklerinizi global acente ağımız ile güvenli çözümlerle taşıyoruz.' },
  { icon: 'ri-global-line', title: 'Global Acente Ağı', desc: 'Dünyanın dört bir yanında ağır tonajlı ithalat ve ihracat yüklerinize güvenli çözümler üretiyoruz.' },
  { icon: 'ri-customer-service-2-line', title: 'Stratejik İş Ortağı', desc: 'Müşterilerimizin stratejik iş ortağı olma felsefesiyle hareket ederek en iyi çözümleri sunuyoruz.' },
];

const modes = [
  { icon: 'ri-flight-takeoff-line', label: 'Havayolu', sub: 'Air Freight' },
  { icon: 'ri-truck-line', label: 'Karayolu', sub: 'Road Freight' },
  { icon: 'ri-ship-line', label: 'Denizyolu', sub: 'Sea Freight' },
  { icon: 'ri-train-line', label: 'Demiryolu', sub: 'Rail Freight' },
];

export default function KargoTasimaciligiPage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=massive%20cargo%20ship%20in%20busy%20international%20port%20at%20dusk%2C%20colorful%20shipping%20containers%20stacked%20high%2C%20cranes%20silhouetted%20against%20dramatic%20orange%20sunset%20sky%2C%20reflections%20on%20water%2C%20industrial%20scale%20logistics%2C%20cinematic%20wide%20angle%20photography%2C%20deep%20shadows%20and%20warm%20highlights&width=1920&height=680&seq=kargo-hero-01&orientation=landscape"
            alt="Kargo Taşımacılığı"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(8,10,20,0.92) 0%, rgba(12,18,38,0.80) 55%, rgba(8,10,20,0.50) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute bottom-16 left-20 w-96 h-96 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(140px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Uluslararası Kargo Taşımacılığı</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-ship-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>Uluslararası Kargo Taşımacılığı</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Dünyaya Açılan<br />
                <span style={{ color: 'var(--orange)' }}>Kargo Çözümleri</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                Müşterilerimizin stratejik iş ortağı olma felsefesiyle, dünyanın dört bir yanında ağır tonajlı ithalat ve ihracat yüklerinize global acente ağımız ile güvenli çözümler üretiyoruz.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[
                { val: 'LTL', lbl: 'Parsiyel' },
                { val: 'FTL', lbl: 'Full Kamyon' },
                { val: 'FCL', lbl: 'Konteyner' },
                { val: 'AIR', lbl: 'Havayolu' },
              ].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Transport modes */}
      <section className="py-12" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {modes.map((m, i) => (
              <div key={i} className="flex items-center gap-4 p-5 rounded-2xl" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${m.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <div>
                  <div className="font-bold text-sm" style={{ color: 'var(--text1)' }}>{m.label}</div>
                  <div className="text-xs" style={{ color: 'var(--text3)' }}>{m.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features + Image */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-16">
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Taşımacılık Çözümlerimiz</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                Müşterilerimizin stratejik iş ortağı olma felsefesiyle hareket ederek, dünyanın dört bir yanında ağır tonajlı ithalat ve ihracat yüklerinize, global acente ağımız ile güvenli çözümler üretiyoruz.
              </p>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                Tüm havayolu, karayolu parsiyel (LTL) ve full kamyon (FTL) ve full konteyner (FCL) yüklerinizi ekonomik çözümlerle teslim ediyoruz.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[280px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20busy%20logistics%20hub%20with%20trucks%20and%20containers%2C%20top%20down%20perspective%20of%20freight%20terminal%2C%20organized%20rows%20of%20colorful%20shipping%20containers%2C%20warm%20afternoon%20light%2C%20industrial%20photography%2C%20clean%20composition&width=420&height=280&seq=kargo-content-01&orientation=landscape"
                alt="Kargo operasyon"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Kargo Taşımacılığı İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Uzman ekibimiz en uygun fiyat ve en hızlı çözümü sizin için hazırlasın.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
